"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartNetworker_1 = require("./CartNetworker");
var EndPointsConfig_1 = require("./EndPointsConfig");
var ReportingService_1 = require("./ReportingService");
var StateProvider_1 = require("./StateProvider");
var Events_1 = require("./Events");
var Utils = require("../utils/UtilityFunctions");
var WirelessProductRexRespnseMapper_1 = require("../models/mappers/WirelessProductRexRespnseMapper");
var FeatureResponseMapper_1 = require("../models/mappers/FeatureResponseMapper");
var CartApi = /** @class */ (function () {
    function CartApi() {
        this.paymentErrorServiceName = 'paymentErrorEvent';
        this.autoPaymentErrorServiceName = 'autoPaymentErrorEvent';
        this.addressErrorServiceName = 'orderPostAddressErrorEvent';
        this.riskAssessmentService = 'riskAssesment';
        this.networker = new CartNetworker_1.default();
        this.reportingService = new ReportingService_1.default();
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        this.events = new Events_1.default([this.paymentErrorServiceName, this.autoPaymentErrorServiceName,
            this.addressErrorServiceName, this.riskAssessmentService]);
    }
    CartApi.prototype.getAdobeMIDValue = function (browserCookie) {
        var mcmidvalue = '';
        if (browserCookie && browserCookie.length > 0 && browserCookie.indexOf('%7CMCMID%7C') > 0) {
            var splitMIDValue = browserCookie.substring(browserCookie.indexOf('%7CMCMID%7C') + 11, browserCookie.length + 1);
            mcmidvalue = splitMIDValue.substring(0, splitMIDValue.indexOf('%7C'));
        }
        return mcmidvalue;
    };
    CartApi.prototype.getFeatures = function () {
        return this.networker.get(EndPointsConfig_1.default.featureAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new FeatureResponseMapper_1.FeatureResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CartApi.prototype.getWirelessProductRex = function (deviceSkus, planSku) {
        return this.networker.get(EndPointsConfig_1.default.wirelessProductRexMSAPI + "?deviceSkus=" + deviceSkus + "&planSku=" + planSku, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new WirelessProductRexRespnseMapper_1.WirelessProductRexRespnseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CartApi.prototype.logToSplunk = function (data) {
        // do not worry about the response, whatever data needed just send the data and forget.
        // do not log anything from the response on the console for security reasons.
        var hdrs = Utils.getInitialHeaders();
        hdrs.append('idp-reasonCode', data.hdrReasonCode ? data.hdrReasonCode : 'UNKNOWN');
        hdrs.append('idp-logType', data.type);
        var errors = [];
        errors.push(data.data);
        this.networker.post(EndPointsConfig_1.default.loggingMSAPI, { messages: errors }, {
            headers: hdrs,
        })
            .then(function () {
            // console.log('logged error to splunk');
        })
            .catch(function (error) {
            // console.error('could not send error to Splunk', error);
        });
    };
    return CartApi;
}());
exports.default = CartApi;
//# sourceMappingURL=CartApi.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/CartApi.js
// module id = 1446
// module chunks = 8